<template>
  <div class="betgameeditcolors" id="betgameeditcolors">

    <NavigationBar>
      <template v-slot:left>
        <img class="back" src="../assets/icons/ic_16_back.svg" v-on:click="goBack" data-testid="nav-back">
      </template>
      <template v-slot:center>
        {{ $t('betgame_settings.betgame_colors') }}
      </template>
    </NavigationBar>
    
    <form @submit.prevent="changeColors">
      <div class="input-container" style="margin-top: 16px;">
        <div>
          <div class="input-header">
            {{ $t('betgame_settings.betgame_colors') }}
          </div>
          <div class="input-infotext">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod....
          </div>
          <div style="margin-top: 16px;">
            <input type="color" id="primary_color" v-on:change="clickColor('primary_color')" v-model="p_color" data-testid="betgame-colors-primary">
            <!-- <input type="text" id="primary_color" name="primary_color" v-model="p_color" /> -->
            <label style="margin-left: 16px;" for="primary_color">{{ $t('betgame_settings.primary_color') }}</label>
          </div>
          <div style="margin-top: 16px;">
            <input type="color" id="button_color" v-on:change="clickColor('button_color')" v-model="b_color" data-testid="betgame-colors-button">
            <!-- <input type="text" id="button_color" name="button_color" v-model="b_color" /> -->
            <label style="margin-left: 16px;" for="button_color">{{ $t('betgame_settings.button_color') }}</label>
          </div>
          <div style="margin-top: 16px;">
            <input type="color" id="link_color" v-on:change="clickColor('link_color')" v-model="l_color" data-testid="betgame-colors-link">
            <!-- <input type="text" id="link_color" name="link_color" v-model="l_color" /> -->
            <label style="margin-left: 16px;" for="link_color">{{ $t('betgame_settings.link_color') }}</label>
          </div>
        </div>
        <div class="input-button-row">
          <button name="button" type="submit" data-testid="betgame-colors-save">
            {{ $t('button_save_text') }}
          </button>
        </div>
      </div>
    </form>
    
  </div>
</template>

<script>

import NavigationBar from './../components/NavigationBar'
import { TOAST_DURATION } from '../main'

export default {
  name: 'BetgameEditColors',
  components: { NavigationBar },
  data () {
    return {
      p_color: null,
      b_color: null,
      l_color: null,
    }
  },
  created () {
    if(this.$store.state.betgame) {
      this.p_color = this.$store.state.betgame.primary_color
      this.b_color = this.$store.state.betgame.button_color
      this.l_color = this.$store.state.betgame.link_color
    }
  },
  mounted () {
    if (this.$store.state.betgame === null || this.$store.state.betgame === undefined) {
      this.goBack()
    }
  },
  computed: {},
  methods: {
    clickColor( type) {
    },
    updateBetgame (data) {
      this.$store.dispatch('patchBetgame', data)
      .then(() => {
        this.$toast.open({
          message: this.$i18n.t('save_changes_success'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'success'
        })
        this.styleDocument()
        this.goBack()
      })
      .catch(function (error) {
        this.$toast.open({
          message: this.$i18n.t('save_changes_error'),
          position: 'top',
          duration: TOAST_DURATION,
          type: 'error'
        })
      })
      .finally(function () {
      })
    },
    goBack () {
      this.$router.push('/betgameedit')
    },
    changeColors () {
      if(this.$store.state.betgame.primary_color !== this.p_color ||
         this.$store.state.betgame.button_color !== this.b_color ||
         this.$store.state.betgame.link_color !== this.l_color) {
        this.updateBetgame({ primary_color: this.p_color, button_color: this.b_color, link_color: this.l_color })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.betgameeditcolors {

  form {
    padding-top: 16px;
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 26px;
  }
}


.grouped {
  margin-top: -16px;
}

.table-view {
  margin-bottom: 0;
}

.table-view-cell:last-child {
  border-bottom: 0;
}

.table-view-cell-label {
  color: rgba(var(--color-text-rgb), .48);
  font-weight: 400;
}
</style>
